'use strict'

import stageFormDefinition from './stageFormDefinition.js';

let lessonEntry=[
  {
    name: "summary",
    fields: [
      { name: "title" },
      { name: "type", options: [
        {value: "project"},
//        {value:"program"},
        {value:"portfolio"},
        {value:"corporate"}
      ] },
      { name: "priority", options: [{value:"high"},{value:"medium"},{value:"low"}], defaultValue:"medium"}
    ]
  },
  {
    name: "detail",
    fields: [
      { name: "effect", height: 2, plainText:true },
      { name: "event", height: 2, plainText:true },
      { name: "cause", height: 2, plainText:true },
      { name: "description", height: 2, optional: true }
    ]
  },
  {
    name:"followUp",
    fields: [
      { name: "indicators", height:2 },
      { name: "recommendations", height: 2 }
    ]
  }
];


export default [
  {
    name: "planApproach",
    fields: [
      { name: "methods", height: 3 },
      { name: "resources", height: 3 },
      { name: "technology", height: 3 },
      { name: "rollOut", height: 3 },
      { name: "other", height: 3}
    ]
  },
  {
    name:"schedule",
    hideButtons:true,
    fields: [
      {
        name:"schedule",
        optional: true,
        type:"multiTable",
        options: {
          addEntry: {
            formDefinition: stageFormDefinition
          },
          edit: {
            formDefinition: stageFormDefinition
          },
          summaryRow: {
            editable: false
          }
        },
        columnHeaders: [
          { name: "stage", columns: 1 },
          { name: "time", columns: 3 },
          { name: "cost", columns: 5 }
        ],
        columns: [
          { name: "name" },
          { name: "start", type:"date" },
          { name: "end", type: "date" },
          { name: "timeTolerance" },
          { name: "hours" },
          { name: "expences" },
          { name: "investments" },
          { name: "sum" },
          { name: "costTolerance" }
        ],
      }
    ]
  },
  {
    name: "lessons",
    hideButtons:true,
    fields: [
      {
        name: "lessonLog",
        type:"table",
        columns: [
          { name: "no", priority: true },
          { name: "title" },
          { name: "priorityLabel" },
          { name: "recommendations" }
        ],
        options: {
          addEntry: {
            formDefinition: lessonEntry
          },
          edit: {
            formDefinition: lessonEntry
          }
        }
      }
    ]
  },
  {
    name: "projectControls",
    fields: [
      { name: "projectControls", height: 8 }
    ]
  }
]



// WEBPACK FOOTER //
// ./views/plan/formDefinition.js